/**
 * Quixo expert review desk (staff console, admin.quixomarketing.com) - owner: track T10 (audit-remediation).
 * The admin route table (routes/admin/index.tsx, owner ui-agency-admin) splices these under StaffGate
 * (integration request in docs/status/aa-t10.md):  children: [...existing, ...auditExpertRoutes]
 * The server gates every call (admin surface, staff roles, flag audit.expert).
 */
import type { RouteObject } from 'react-router';
import { ExpertBookingsPage, ExpertQueuePage, ExpertReviewPage, ExpertThreadPage } from './screens';

export const auditExpertRoutes: RouteObject[] = [
  { path: 'audit-expert', element: <ExpertQueuePage /> },
  { path: 'audit-expert/bookings', element: <ExpertBookingsPage /> },
  { path: 'audit-expert/:tenantId/threads/:threadId', element: <ExpertThreadPage /> },
  { path: 'audit-expert/:tenantId/:jobId', element: <ExpertReviewPage /> },
];

export { ExpertBookingsPage, ExpertQueuePage, ExpertReviewPage, ExpertThreadPage };
